<template>
  <div id="LoginPage">
    <div id="loginPageButtons" v-if="!shouldShowLogin && !shouldShowSignup">
      <button @click="shouldShowSignup = true">New Account</button>
      <button class="sec" @click="shouldShowLogin = true">Log in</button>
    </div>
    <div id="signUp" v-if="shouldShowSignup">
      <br /><br /><br />
      <form
        action="/"
        id="signUpForm"
        v-on:submit.prevent
        v-on:submit="submitSignUp"
      >
        <label for="pairingcode"
          >Pairing code <span class="required">*</span></label
        >
        <br />
        <input type="text" id="pairingcode" required ref="pairingcode" /> <br />
        <label for="username">Username <span class="required">*</span></label>
        <br />
        <input type="text" id="username" required ref="username" /> <br />
        <label for="password">Password <span class="required">*</span></label>
        <br />
        <input type="password" id="password" required ref="password" /> <br />
        <label for="firstname"
          >First name <span class="required">*</span></label
        >
        <br />
        <input type="text" id="firstname" required ref="firstname" /> <br />
        <label for="lastname">Last name <span class="required">*</span></label>
        <br />
        <input type="text" id="lastname" required ref="lastname" /> <br />
        <label for="email">E-mail <span class="required">*</span></label> <br />
        <input type="email" id="email" required ref="email" /> <br />
        <label for="address">Address</label> <br />
        <input type="text" id="address" ref="address" /> <br />
        <br /><br />
        <button type="submit">Sign Up</button>
      </form>
    </div>
    <div id="logIn" v-if="shouldShowLogin">
      <form
        action="/"
        id="loginForm"
        v-on:submit.prevent
        v-on:submit="submitLogin"
      >
        <label for="username">Username</label> <br />
        <input type="text" id="username" required ref="username" /> <br /><br />
        <label for="password">Password</label> <br />
        <input type="password" id="password" required ref="password" />
        <br /><br />
        <button type="submit">Log in</button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import axios from "axios";
import { defineComponent } from "vue";
import API_URL from "@/api_url";

export default defineComponent({
  name: "HeaderBar",
  data() {
    return {
      shouldShowLogin: false,
      shouldShowSignup: false,
    };
  },
  methods: {
    async submitLogin() {
      const r = this.$refs as {
        username: HTMLInputElement;
        password: HTMLInputElement;
      };
      const username = r.username.value;
      const password = r.password.value;

      const res = await axios.post(
        `${API_URL}/auth`,
        {
          username: username,
          password: password,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.failed) {
        if (res.data.errorCode === 2) {
          alert("Login failed! Invalid credentials!");
        } else {
          alert("Something went wrong wth login!");
        }
      } else {
        window.location.reload();
      }
    },
    async submitSignUp() {
      const r = this.$refs as {
        pairingcode: HTMLInputElement;
        username: HTMLInputElement;
        password: HTMLInputElement;
        firstname: HTMLInputElement;
        lastname: HTMLInputElement;
        email: HTMLInputElement;
        address: HTMLInputElement;
      };

      const pairingcode = r.pairingcode.value;
      const username = r.username.value;
      const password = r.password.value;
      const firstname = r.firstname.value;
      const lastname = r.lastname.value;
      const email = r.email.value;
      const address = r.address.value || "";

      const res = await axios.post(`${API_URL}/auth/register`, {
        pairingcode: pairingcode,
        username: username,
        password: password,
        firstname: firstname,
        lastname: lastname,
        email: email,
        address: address,
      });

      if (res.data.failed) {
        if (res.data.errorCode === 10) {
          alert(
            "Sign up failed! User with that Email or username already exists!"
          );
        } else {
          alert("Something went wrong during signup!");
        }
      } else {
        this.submitLogin();
      }
    },
  },
});
</script>

<style>
#LoginPage {
  background-color: var(--background);
  width: 100vw;
  height: 100vh;
  z-index: 300;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#loginPageButtons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

#logIn {
  display: flex;
  flex-direction: column;
}

input {
  border: var(--text) 2px solid;
  border-radius: 5px;
  padding: 15px;
  width: 60vw;
  background-color: var(--background);
}

.required {
  color: red;
}
</style>
